import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FollowButton from '../../Util/Buttons/FollowButton/FollowButton';
import './ProjectDetailHeader.scss';
import BackButton from '../../Util/Buttons/BackButton/BackButton';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isMobile } from '../../../services/booleanUtil';
import { trackActionClicked } from '../../../api/trackActionClickedApi';
import { TrackedActions } from '../../../models/TrackedActionsEnum';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { setFollowUnfollow } from '../../../redux/actions/currentProject';
import ConvergenceButton from '../../Util/Buttons/ConvergenceButton/ConvergenceButton';
import { MoonLoader } from 'react-spinners';
import { ShouldRenderPMRProjectReport } from '../../Projects/ProjectsReport/utils/Validators/ReportValidations';
import { ReactComponent as IconReport } from '../../../assets/icons/u_reports.svg';
import { OnePagerReportButton } from '../../Util/Buttons/OnePagerReportButton/OnePagerReportButton';

export const ProjectDetailHeader = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { currentProject } = useSelector<any, any>(state => state);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isPMRType = ShouldRenderPMRProjectReport(
    currentProject?.projectProductType,
    currentProject.projectProductTypeClassification?.code,
  );

  const handleFollow = () => {
    dispatch(setFollowUnfollow(currentProject.id));
    if (!currentProject.inFollow) {
      trackActionClicked(TrackedActions.followProjectFromDetailsClicked);
    }
  };
  const handleReport = () => {
    history.push(`/onepagerreport?from=project&id=${currentProject.id}&code=${currentProject.code}&isPMRType=${isPMRType}`);
  };
  const goBack = () => {
    history.push('/home');
  };

  const renderHeaderTitle = () => {
    return currentProject.projectProductType === ProjectProductTypes.IG ? t('igr_detail') : t('project_detail');
  };

  return (
    <div className="project-detail-header-container">
      <div className="back-title">
        <BackButton handleClick={goBack} />
        {!isMobile() && <h2>{renderHeaderTitle()}</h2>}
      </div>
      <div className="buttons">
        <FollowButton follow={currentProject.inFollow} handleClick={handleFollow} />

        <OnePagerReportButton
          from="project"
          projectId={currentProject?.id}
          projectCode={currentProject?.code}
          isPMRType={isPMRType}
        />

        <ConvergenceButton
          customStyle={{ marginLeft: isMobile() ? '10px' : '17px' }}
          projectCode={currentProject.code}
        />
      </div>
    </div>
  );
};

export default ProjectDetailHeader;
